import styles from './styles.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import Header from '../../../components/header/Header';
import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import ButtonNetwork from '../../../utils/network-connect/ButtonNetwork';
import { hasEmail, showNotificationDialog } from '../../../utils';
import isOnline from '../../../utils/network-connect/NetworkConnect';
import { EMAIL_REGEX_PATTERN, IS_IN_PURCHASE } from '../../../utils/Constants';

/**
 * 図14-1 メールアドレス変更新メールアドレス入力画面
 */
const ChangeEmailScreen = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { updateUserAttributes, user } = useFujiAuth();
    const { isInPurchase } = useLocation().state ?? {};

    /**
     * メールアドレス変更処理の実行
     */
    const onFinish = ({ email }: { email: string }) => {
        if (isOnline()) {
            // 小文字に変換する
            const emailLower = email.trim().toLowerCase();
            //ローディングを表示
            setIsLoading(true);
            updateUserAttributes({ email: emailLower }, ({ isSuccessed }: { isSuccessed: boolean }) => {
                //ローディングを非表示
                setIsLoading(false);
                if (isSuccessed) {
                    //ユーザー情報ページに遷移
                    if (isInPurchase) {
                        localStorage.setItem(IS_IN_PURCHASE, 'true');
                    }
                    navigate('/profile/info/confirm', { state: { email: emailLower } });
                } else {
                    // MSG.10-E2 メールアドレス更新失敗エラー
                    showNotificationDialog(
                        'failed',
                        'change-mail-failed',
                        t('notification.title'),
                        t('error-message.user-info.change-info-failed'),
                    );
                }
            });
        } else {
            showNotificationDialog('error', '', t('notification.title'), t('error-message.server-error'));
        }
    };

    const onFinishFailed = () => {};
    return (
        <React.Fragment>
            {isLoading && <CenterLoading overFooter={true} />}
            <Header title={t('header.change-mail')} />
            <div className={`content-footer-container scrollable ${styles.changeMailContainer}`}>
                <div className={styles.content}>
                    {user && hasEmail(user) && (
                        <div className={styles.title}>
                            <p>{t('change-mail.current-mail')}</p>
                            <p>{user && user?.email?.toLowerCase()}</p>
                        </div>
                    )}
                    <Form
                        className={styles.changeForm}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                    >
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    pattern: EMAIL_REGEX_PATTERN,
                                    message: t('validate.correct-email') ?? '',
                                },
                                {
                                    required: true,
                                    message: t('validate.email') ?? '',
                                },
                                () => ({
                                    validator(_, value) {
                                        if (!value || user?.email?.toLowerCase() !== value.trim().toLowerCase()) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(t('error-message.user-info.already-registered-email') ?? ''),
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input
                                style={{ borderRadius: 4, height: 50 }}
                                placeholder={t('form.new-email') ?? ''}
                                type="email"
                            />
                        </Form.Item>
                        <p className={styles.mailNote}>{t('change-mail.note')}</p>
                        <Form.Item>
                            <div className={styles.btnSubmit}>
                                <ButtonNetwork title={t('button.send')} />
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ChangeEmailScreen;
